export enum NotificationStatusEnum {
    CREATED,
    CANCELLED,
    EXPIRED,
    ACKNOWLEDGED,
    UPDATE,
    SENT,
    DELETED
}
